import React from "react";
import "../../OptionBlocks/Logos/Logos.css";

const UploadFontModal = ({
  handleCancelUpload,
  fontToUpload,
  handleConfirmUpload
}) => {
  const handleNo = () => {
    handleCancelUpload();
  };

  const handleConfirm = () => {
    handleConfirmUpload(fontToUpload);
  };

  return (
    <div className="logoEdit-container">
      <div className="logoEdit-overlay" onClick={handleNo} />
      <div className="logoEdit-content p-4">
        <h2 className="manrope-800 text-[1.2rem] text-white mt-2">
          Please Confirm the following
        </h2>
        <p className="w-[25rem] manrope-400 mt-[1rem] text-[0.9rem]  text-white">
          By uploading my own custom font, I acknowledge that I own{" "}
          <b>{fontToUpload?.name}</b> or have the right to use it for my intended
          purposes.
        </p>
        <div className="flex p-2 gap-4 justify-end mt-4 text-gray-900">
          <button className="updateLogoEditNoBtn" onClick={handleNo}>
            Cancel
          </button>
          <button
            className="updateLogoEdit"
            onClick={handleConfirm}
          >
            Yes, upload it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadFontModal;
